import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { finalize, tap } from "rxjs/operators";

import { DffRouteParams } from "@dffedb/router";
import { ToastService } from "@dffedb/ui";
import { LoginService } from "@e-forsyning/common/auth";
import { RedirectService } from "@e-forsyning/common/router";

import { GlemtKodeordFormBuilder } from "./glemt-kodeord-form-builder";

@Component({
    selector: "glemt-kodeord",
    templateUrl: "./glemt-kodeord.component.html"
})
export class GlemtKodeordComponent implements OnInit {
    public form: UntypedFormGroup;
    public loginFejl = false;
    public fejlBesked = "";
    public key: string;
    public arbejder = false;
    constructor(
        private readonly routeParams: DffRouteParams,
        private readonly loginService: LoginService,
        private readonly toastService: ToastService,
        private readonly redirectService: RedirectService
    ) {}

    public ngOnInit(): void {
        this.key = this.routeParams.get("guid");
        this.form = GlemtKodeordFormBuilder.opretForm();
    }

    public glemtKodeordClick(): void {
        if (this.form.valid) {
            this.arbejder = true;
            this.loginService
                .resetPwd(this.form.get("nytKodeord").value, this.key)
                .pipe(
                    tap(() => {
                        this.toastService.visInfo("Dit kodeord er nu ændret.");
                        this.redirectService.redirectTilLogin();
                    }),
                    finalize(() => {
                        this.arbejder = false;
                    })
                )
                .subscribe();
        }
    }
}
